import DashboardScreen from '../components/Home/DashboardScreen';
import AtsPipeline from '../components/AtsPipeline/AtsPipeline';
import RoleManager from '../components/RoleManager/RoleManager';
import ModuleManager from '../components/SuperAdmin/ModuleManager';
import Sourcing from '../components/Sourcing/Sourcing';
import CompanyProfile from '../components/CompanyProfile/CompanyProfile';
import CompanyDetails from '../components/SuperAdmin/CompanyDetails';
import UserDetails from '../components/SuperAdmin/UserDetails';
import AllPostedJobs from '../components/Jobs/AllPostedJobs';
import JobPost from '../components/Jobs/JobPost';
import CompanyRegistration from '../components/Registration/CompanyRegistration/CompanyRegistration';
import UserRegistration from '../components/Registration/UserRegistration/UserRegistration';
import AccessControl from '../components/SuperAdmin/AccessControl';
import AssignRecruiter from '../components/AssignRecruiter/AssignRecruiter';
import AdminReport from '../components/AdminReport/AdminReport';
import InterviewSchedule from '../components/InterviewSchedule/InterviewSchedule';
import ScreenedCandidate from '../components/AdminReport/ScreenedCandidate';
import ReportAndAnalysis from '../components/ReportAndAnalysis/ReportAndAnalysis';
import CvManegement from '../components/CvManegement/CvManegement';
import SourcedCandidate from '../components/Sourcing/SourcedCandidate';
import SourcingList from '../components/Sourcing/SourcingList';

export const userRoutes = [
    { path: '/', element: <DashboardScreen /> },
    { path: '/master-role', element: <RoleManager /> },
    { path: '/module', element: <ModuleManager /> },
    { path: '/daily-sourcing-update/:index', element: <Sourcing /> },
    { path: '/sourced-candidate', element: <SourcedCandidate /> },
    { path: '/sourcing-list/:index', element: <SourcingList /> },
    { path: '/ats-pipeline/:index', element: <AtsPipeline /> },
    { path: '/company-profile', element: <CompanyProfile /> },
    { path: '/company-details/:index', element: <CompanyDetails /> },
    { path: '/user-details/:index', element: <UserDetails /> },
    { path: '/all-posted-jobs/:index', element: <AllPostedJobs /> },
    { path: '/post-job/:index', element: <JobPost /> },
    { path: '/company-registration/:index', element: <CompanyRegistration /> },
    { path: '/user-registration/:index', element: <UserRegistration /> },
    { path: '/access-control', element: <AccessControl /> },
    { path: '/assign-recruiter/:index', element: <AssignRecruiter /> },
    { path: '/admin-report/:index', element: <AdminReport /> },
    { path: '/interview-schedule/:index', element: <InterviewSchedule /> },
    { path: '/screened-candidates/:index', element: <ScreenedCandidate /> },
    { path: '/report-and-analysis/:index', element: <ReportAndAnalysis /> },
    { path: '/cv-management/:index', element: <CvManegement /> },
];



